<ng-container *ngIf="buttononly; else chooseValue">

    <div class="ask-report buttononly" [ngClass]="checkingForAfChannel$()" [class.active]="checkingForAfChannel$()"
        [class.offline]="checkingForAfChannel$() === 'offline'"
        [class.livechat]="checkingForAfChannel$() === 'livechat'"
        [class.connecting]="checkingForAfChannel$() === 'In connessione ...'"
        [class.fw]="buttonfw">
        <button mat-flat-button (click)="getReportSubmit(true)" color="primary" class="p--24 button-ask" *ngIf="!checkingForAfChannel$()" [class.fw]="buttonfw" [ngClass]="buttonclass">
            {{ buttonlabel | translate}}
        </button>
        <div class="connection-animation-wrapper d-flex flex-column" *ngIf="checkingForAfChannel$()">
            <div class="message-connecting" *ngIf="checkingForAfChannel$() === 'In connessione ...'">{{'Ti stiamo connettendo in chat con un consulente dedicato ... ' | translate }}</div>
            <div class="connection-animation " >
                <div class="ani d-flex gap-8">
                    <div class="di di-3x di-chat"></div>
                    <div class="dots">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </div>
                    <div class="di di-3x"
                        [ngClass]="{'di-assistance': checkingForAfChannel$() === 'livechat', 'di-edit': checkingForAfChannel$() === 'offline' }">
                    </div>
                </div>
                <div class="connectionstatus text-uppercase">
                    {{ checkingForAfChannel$()}}
                </div>

            </div>
        </div>
    </div>
</ng-container>

<ng-template #chooseValue>
<!-- choose value report template-->
    <div id="discoverFeatures" class="container page-wrapper fvh pt--64">
        <div class="row ai-center jc-center">
            <div class="col-12 text-center  column align-items-center gap-24 pt--64 pb--64">
                <h2 translate class="page-title-responsive">Se si, quanto vale per te questa informazione?</h2>
                <mat-radio-group aria-label="Select an option" [(ngModel)]="myInformationValue"
                    class="row gap-24 pb--64 value-report">
                    <mat-radio-button [value]="range.value" class="col value-report-value"
                        *ngFor="let range of ranges$()">{{range.label}}</mat-radio-button>
                </mat-radio-group>
                <!-- <ng-container *ngIf="!checkingForAfChannel$()"> ->
                <button mat-fab extended (click)="getReportSubmit()" [disabled]="!myInformationValue" color="primary"
                    class="p--24 button-ask-report">
                    <h5 class="m--0" translate>Clicca qui per ottenere queste informazioni </h5>
                </button> 
             </ng-container> 
           -->

                <div class="ask-report" [ngClass]="checkingForAfChannel$()" [class.active]="myInformationValue"
                    [class.offline]="checkingForAfChannel$() === 'offline'"
                    [class.livechat]="checkingForAfChannel$() === 'livechat'"
                    [class.connecting]="checkingForAfChannel$() === 'In connessione ...'">
                    <button mat-fab extended (click)="getReportSubmit()" [disabled]="!myInformationValue"
                        color="primary" class="p--24 button-ask">
                        <h5 class="m--0" translate>Clicca qui per ottenere queste informazioni </h5>
                    </button>
                    <div class="connection-animation ">
                        <div class="ani d-flex gap-8">
                            <div class="di di-3x di-chat"></div>
                            <div class="dots">
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                            </div>
                            <div class="di di-3x"
                                [ngClass]="{'di-assistance': checkingForAfChannel$() === 'livechat', 'di-edit': checkingForAfChannel$() === 'offline' }">
                            </div>
                        </div>
                        <div class="connectionstatus text-uppercase">
                            {{ checkingForAfChannel$()}}
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>
</ng-template>